import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=adbde35c&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Entities.vue"
export default component.exports